import { SurveyChapterInsight } from "../../types/workplaceCulture";

export const storyInsightsWidgetData: SurveyChapterInsight[] = [
  {
    id: "1",
    dispatch_id: "1",
    chapter_id: "1",
    insight:
      "12% of respondents have experienced toxic environment in the past 12 months",
    order: 1,
    percentage: 12,
    benchmark_percentage: 0,
    question_id: "1",
  },
  {
    id: "2",
    dispatch_id: "1",
    chapter_id: "1",
    insight:
      "24% of respondents have had trouble with maintaining work life balance in the past 12 months",
    order: 2,
    percentage: 24,
    benchmark_percentage: 25,
    question_id: "2",
  },
];

export const mockInsightsWidgetData: SurveyChapterInsight[] = [
  {
    id: "1",
    dispatch_id: "1",
    chapter_id: "S.CHA.003",
    insight:
      "65% of respondents feel that leaders and managers are committed to creating an inclusive workplace",
    order: 1,
    percentage: 65,
    benchmark_percentage: 69,
    question_id: "QUE.001",
  },
  {
    id: "2",
    dispatch_id: "1",
    chapter_id: "S.CHA.002",
    insight:
      "48% of respondents feel that leadership/management supports their career growth and development very or fairly well",
    order: 2,
    percentage: 48,
    benchmark_percentage: 74,
    question_id: "QUE.002",
  },
];
